<script>
    import { Line } from 'vue-chartjs'
    import createChart from './mixins/createChart'

    export default {
        extends: Line,

        mixins: [createChart],

        props: {
            chartData: {
                type: Object,
                required: true,
                default: () => {}
            },

            options: {
                type: Object,
                default: () => {
                    return {
                        legend: {
                            display: false
                        },

                        scales: {
                            xAxes: [{
                                gridLines: {
                                    color: '#40424F',
                                    drawTicks: false,
                                    drawBorder: 0
                                },
                                ticks: {
                                    fontColor: '#fff',
                                    fontFamily: "'proxima-nova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                    padding: 8
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    beginAtZero: false,
                                    fontColor: '#fff',
                                    fontFamily: "'proxima-nova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                    padding: 8
                                }
                            }]
                        }
                    }
                }
            },

            scheme: {
                type: String,
                default: 'dark'
            },
        },

        data () {
            return {
                gradient: null,

                targetDataStyling: {
                    borderColor: '#ffffff',
                    borderDash: [4, 4],
                    borderWidth: 1,

                    pointHitRadius: 12,
                    pointStyle: 'circle',
                    pointBackgroundColor: 'rgba(0, 0, 0, 0)',
                    pointBorderColor: 'rgba(0, 0, 0, 0)',
                    pointBorderWidth: 0,
                    pointRadius: 2,

                },

            }
        },

        mounted () {
            this.options.scales.xAxes[0].ticks.fontColor = this.isDarkScheme ? '#fff' : '#000'
            this.options.scales.yAxes[0].ticks.fontColor = this.isDarkScheme ? '#fff' : '#000'

            this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 230)

            this.gradient.addColorStop(0.000, 'rgba(24, 189, 203, 0.300)');
            this.gradient.addColorStop(1.000, 'rgba(24, 189, 203, 0.000)');

            this.dataStyling = {
                backgroundColor: this.gradient,
                borderColor: '#18BDCB',
                pointBackgroundColor: '#18BDCB',
                borderWidth: 1,
                hitRadius: 12,
                hoverRadius: 2,
                pointStyle: 'circle',
                radius: 2,
            }

            this.targetsKey()
        },

        methods: {
            targetsKey() {

                if (this.hasTargets) {
                    $(this.$refs.canvas).after('<div class="flex items-center relative w-full mt-10 text-14"><span class="inline-block w-14 h-1 mr-8 border-t border-white border-dashed"></span> Target</div>')
                }

            }


        }
    }
</script>